import { render, staticRenderFns } from "./Elogios.vue?vue&type=template&id=473f0987&scoped=true"
import script from "./Elogios.vue?vue&type=script&lang=js"
export * from "./Elogios.vue?vue&type=script&lang=js"
import style0 from "./Elogios.vue?vue&type=style&index=0&id=473f0987&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473f0987",
  null
  
)

export default component.exports